import styled from 'styled-components';
import { COLORS } from 'Permafrost/constants';

export const StyledFilterSelectControls = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin: 0 var(--pf-padding-3) var(--pf-padding-3) 0;

  .apply-btn {
    background-color: ${COLORS.summerSky};
    border-radius: 10px;
    color: ${COLORS.white};
  }

  .cancel-btn {
    background: none;
    box-shadow: none;
    color: ${COLORS.defaultFontColor};
    margin-right: var(--pf-padding-2);
  }
`;
